// UNA sola definición de "este envío lo hacemos nosotros".
//
// Antes la regla estaba duplicada en dos lugares con criterios distintos y las dos
// copias tenían el mismo bug: pedían `source === 'manual'` o un `shipping_option` de
// logística propia. Pero NewOrder graba el CANAL de origen (ig / whatsapp / showroom),
// no 'manual', y solo escribe shipping_option si se tilda "Envío gratis". Resultado:
// las ventas cargadas a mano con envío (61 en 120 días) quedaban afuera de Cabify Y
// tampoco recibían el WhatsApp de despacho.
//
// Criterio: si la venta la cargamos nosotros (cualquier canal propio), el envío es
// nuestro. Las de canal externo (Tiendanube; antes también WooCommerce) solo si su shipping_option
// lo dice: las demás viajan por el correo del canal y no las despachamos nosotros.

/** Canales donde la venta la carga el equipo → el envío es nuestro. */
export const OWN_SOURCES = ['manual', 'ig', 'whatsapp', 'showroom'];

const OWN_SHIPPING_RE = /log[ií]stica propia|env[ií]o gratis|envio gratis/i;

export function isOwnShipping(o: { delivery_type?: string | null; source?: string | null; shipping_option?: string | null }): boolean {
  if (o.delivery_type !== 'envio') return false;
  if (o.source === 'mercadolibre') return false; // ML nunca: tiene su propia logística y no se le manda WhatsApp
  if (OWN_SOURCES.includes(String(o.source || ''))) return true;
  return OWN_SHIPPING_RE.test(o.shipping_option || '');
}
